/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popular searches`)
};

const es_wu_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsquedas populares`)
};

const de_wu_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beliebte Suchen`)
};

const nl_wu_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Populaire zoekopdrachten`)
};

const fr_wu_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recherches populaires`)
};

const it_wu_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricerche popolari`)
};

const pt_br2_wu_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscas populares`)
};

const pt_wu_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisas populares`)
};

const ja_wu_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`よく検索される文字`)
};

const zh_wu_examples_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`热门搜索`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_examples_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_examples_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_examples_title", locale)
	if (locale === "en") return en_wu_examples_title(inputs)
	if (locale === "es") return es_wu_examples_title(inputs)
	if (locale === "de") return de_wu_examples_title(inputs)
	if (locale === "nl") return nl_wu_examples_title(inputs)
	if (locale === "fr") return fr_wu_examples_title(inputs)
	if (locale === "it") return it_wu_examples_title(inputs)
	if (locale === "pt-BR") return pt_br2_wu_examples_title(inputs)
	if (locale === "pt") return pt_wu_examples_title(inputs)
	if (locale === "ja") return ja_wu_examples_title(inputs)
	return zh_wu_examples_title(inputs)
};